// extracted by mini-css-extract-plugin
module.exports = {"list":"category-list_list__1C53x"};